// Lenient URL coercion for user-submitted forms.
// If the user types "example.org" we treat it as "https://example.org" so the
// stored value works as an <a href>. Empty input → null. Strings that already
// have a scheme are returned as-is (case-preserved).

export function coerceUrl(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;
  // Internal SPA links (e.g. /bibliography?author=Foo) — keep as-is.
  if (trimmed.startsWith('/')) return trimmed;
  // Everything else: assume it's a host and prefix https://.
  return `https://${trimmed}`;
}
